import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./AvailabilityForm.css";

type AvailabilityType = Record<string, string[]>;

export default function AvailabilityForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    age: "",
    interest: "Private Coaching",
    notes: "",
  });

  const [availability, setAvailability] = useState<AvailabilityType>({
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const toggleSlot = (day: string, slot: string) => {
    setAvailability((prev) => {
      const selected = prev[day]?.includes(slot)
        ? prev[day].filter((s) => s !== slot)
        : [...(prev[day] || []), slot];
      return { ...prev, [day]: selected };
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // 🧾 Format availability as HTML table for email
    const availabilityTable = `
      <table border="1" cellpadding="8" cellspacing="0" 
             style="border-collapse:collapse;width:100%;text-align:center;font-family:Poppins,sans-serif;">
        <thead>
          <tr style="background-color:#f15a24;color:white;">
            <th>Day</th>
            <th>Morning (10–1)</th>
            <th>Afternoon (2–5)</th>
            <th>Evening (5–8)</th>
            <th>Night (8–11)</th>
          </tr>
        </thead>
        <tbody>
          ${Object.entries(availability)
            .map(
              ([day, slots]) => `
              <tr>
                <td style="font-weight:600;">${day}</td>
                <td>${slots.includes("Morning 10am-1pm") ? "yes" : "—"}</td>
                <td>${slots.includes("Afternoon 1pm-5pm") ? "yes" : "—"}</td>
                <td>${slots.includes("Evening 5pm-8pm") ? "yes" : "—"}</td>
                <td>${slots.includes("Night 8pm-11pm") ? "yes" : "—"}</td>
              </tr>`
            )
            .join("")}
        </tbody>
      </table>
    `;

    const templateParams = {
      ...formData,
      availability_table: availabilityTable,
    };

    emailjs
      .send(
        "service_7wg915y", // your Gmail service ID
        "template_w9cihnc", //  your EmailJS template ID
        templateParams,
        "TmSR43pdEXcy8M__z" //your EmailJS public key
      )
      .then(
        () => {
          alert("✅ Enquiry sent successfully!");

          // 🧹 Reset form fields & selections
          setFormData({
            name: "",
            phone: "",
            age: "",
            interest: "Private Coaching",
            notes: "",
          });
          setAvailability({
            Monday: [],
            Tuesday: [],
            Wednesday: [],
            Thursday: [],
            Friday: [],
            Saturday: [],
            Sunday: [],
          });

          // 🔁 Optionally refresh the form visually
          window.scrollTo(0, 0);
        },
        (error) => alert("❌ Failed to send enquiry: " + error.text)
      );
  };

  const timeSlots = ["Morning 10am-1pm", "Afternoon 1pm-5pm", "Evening 5pm-8pm", "Night 8pm-11pm"];

  return (
    <section className="availability-section">
      <h1>Book Your Coaching Slot</h1>
      <p>
        Fill in your preferred days and time slots. Our coach will contact you
        soon to confirm your booking.
      </p>

      <form onSubmit={handleSubmit} className="availability-form">
        <input
          type="text"
          name="name"
          placeholder="Full Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <input
          type="number"
          name="age"
          placeholder="Age"
          value={formData.age}
          onChange={handleChange}
          required
        />

        <select
          name="interest"
          value={formData.interest}
          onChange={handleChange}
          required
        >
          <option>Private Coaching</option>
          <option>Group Coaching</option>
          <option>Summer Camp 2026</option>
        </select>

        <h3>Select Your Availability</h3>
        <div className="availability-grid">
          {Object.keys(availability).map((day) => (
            <div key={day} className="day-block">
              <h4>{day}</h4>
              <div className="slots">
                {timeSlots.map((slot) => (
                  <button
                    type="button"
                    key={slot}
                    className={
                      availability[day]?.includes(slot) ? "selected" : ""
                    }
                    onClick={() => toggleSlot(day, slot)}
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <textarea
          name="notes"
          placeholder="Additional notes (optional)"
          value={formData.notes}
          onChange={handleChange}
        ></textarea>

        <button type="submit" className="submit-btn">
          Send Enquiry
        </button>
      </form>
    </section>
  );
}
